// P24 (démo du 09/10, D4) — « Barres | Structure », à côté de « Graphique | Tableau ».
//
// Même pilule que la bascule C1 (classe `.obs2-bascule`), même mémoire : la session, par
// graphique (voir `BasculeVue` pour le choix de `sessionStorage`). Le bouton « Structure »
// n'existe que sur une répartition (`etatStructure`), et il marche toujours (Marc, 13/10 :
// plus d'état grisé ni de phrase d'excuse quand plusieurs territoires sont tracés — l'anneau
// en montre un, `ChoixStrate` choisit lequel).
import type { FormeRepartition } from './formeRepartition'
import type { Strate } from './structure'

export function BasculeStructure({ forme, onChange, nom }: {
  forme: FormeRepartition; onChange: (f: FormeRepartition) => void; nom?: string
}) {
  return (
    <div className="obs2-bascule obs2-bascule-forme" role="group"
         aria-label={nom ? `Forme de « ${nom} » : barres ou structure`
                         : 'Forme : barres ou structure'}>
      <button type="button" aria-pressed={forme === 'barres'}
              className={forme === 'barres' ? 'actif' : undefined}
              onClick={() => onChange('barres')}>
        Barres
      </button>
      <button type="button" aria-pressed={forme === 'structure'}
              className={forme === 'structure' ? 'actif' : undefined}
              title="Répartition en anneau, parts en %"
              onClick={() => onChange('structure')}>
        Structure
      </button>
    </div>
  )
}

/** Les territoires tracés, un bouton chacun : un clic redessine l'anneau pour celui-là. Rendu
 *  seulement quand il y a un choix (deux strates ou plus). */
export function ChoixStrate({ strates, choisie, onChange, nom }: {
  strates: Strate[]; choisie: string; onChange: (cle: string) => void; nom?: string
}) {
  return (
    <div className="obs2-strates" role="group"
         aria-label={nom ? `Territoire de l’anneau « ${nom} »` : 'Territoire de l’anneau'}>
      {strates.map((s, i) => (
        <button key={`${i}-${s.cle}`} type="button" aria-pressed={s.cle === choisie}
                className={s.cle === choisie ? 'actif' : undefined}
                onClick={() => onChange(s.cle)}>
          {s.nom ?? s.structure.territoire}
        </button>
      ))}
    </div>
  )
}
